module.exports = __webpack_public_path__ + "hero-expertise-right@2x.3x7ZZ2x9.png";